import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import selectFeatures from './feature/select.js'

export default contract({
  selectFeatures: array([
    selectFeatures
  ])
})